_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[32],{

/***/ "7UQC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("vOnD");
/* harmony import */ var _soundboks_sb_components_src_styles_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("isV7");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;




var SectionWrapper = function SectionWrapper(_ref) {
  var children = _ref.children,
      maxWidth = _ref.maxWidth;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(OuterWrapper, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(InnerWrapper, {
    maxWidth: maxWidth
  }, children));
};

var OuterWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].section.withConfig({
  displayName: "SectionWrapper__OuterWrapper",
  componentId: "sc-1yz6gz9-0"
})(["padding:", "px ", "px;@media ", "{padding:", "px;}"], _soundboks_sb_components_src_styles_theme__WEBPACK_IMPORTED_MODULE_2__[/* Size */ "j"].BaseUnit * 8, _soundboks_sb_components_src_styles_theme__WEBPACK_IMPORTED_MODULE_2__[/* Size */ "j"].BaseUnit * 4, function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.desktop;
}, _soundboks_sb_components_src_styles_theme__WEBPACK_IMPORTED_MODULE_2__[/* Size */ "j"].BaseUnit * 8);
var InnerWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
  displayName: "SectionWrapper__InnerWrapper",
  componentId: "sc-1yz6gz9-1"
})(["max-width:", "px;margin:auto;"], function (_ref3) {
  var maxWidth = _ref3.maxWidth;
  return maxWidth;
});
/* harmony default export */ __webpack_exports__["a"] = (SectionWrapper);

/***/ }),

/***/ "D+Wi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ atoms_Image_Image; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ loaders_imgixLoader; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ ImageLayout; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ ImageRatio; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ types_ImageWidth; });

// UNUSED EXPORTS: ImageWeb, ImageNative, butterLoader, defaultLoader, ImageMediaQuery

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__("ODXe");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Platform/index.js
var Platform = __webpack_require__("Hnp+");
var Platform_default = /*#__PURE__*/__webpack_require__.n(Platform);

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/View/index.js
var View = __webpack_require__("Epja");
var View_default = /*#__PURE__*/__webpack_require__.n(View);

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Animated/index.js
var Animated = __webpack_require__("ilP0");
var Animated_default = /*#__PURE__*/__webpack_require__.n(Animated);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/styles/theme.ts
var theme = __webpack_require__("isV7");

// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Image/types.ts

var ImageLayout;

(function (ImageLayout) {
  ImageLayout["Fill"] = "fill";
  ImageLayout["Responsive"] = "responsive";
  ImageLayout["Fixed"] = "fixed";
})(ImageLayout || (ImageLayout = {}));

var ImageRatio;

(function (ImageRatio) {
  ImageRatio[ImageRatio["Square"] = 1] = "Square";
  ImageRatio[ImageRatio["FourToThree"] = 0.75] = "FourToThree";
  ImageRatio[ImageRatio["ThreeToFour"] = 1.3333333333333333] = "ThreeToFour";
})(ImageRatio || (ImageRatio = {}));

var types_ImageWidth;

(function (ImageWidth) {
  ImageWidth[ImageWidth["ExtraTiny"] = 2.5 * theme["j" /* Size */].BaseUnit] = "ExtraTiny";
  ImageWidth[ImageWidth["Tiny"] = 5 * theme["j" /* Size */].BaseUnit] = "Tiny";
  ImageWidth[ImageWidth["Small"] = 19 * theme["j" /* Size */].BaseUnit] = "Small";
  ImageWidth[ImageWidth["Medium"] = 41 * theme["j" /* Size */].BaseUnit] = "Medium";
  ImageWidth[ImageWidth["Large"] = 72 * theme["j" /* Size */].BaseUnit] = "Large";
  ImageWidth[ImageWidth["ExtraLarge"] = 90 * theme["j" /* Size */].BaseUnit] = "ExtraLarge";
})(types_ImageWidth || (types_ImageWidth = {}));

var ImageMediaQuery;

(function (ImageMediaQuery) {
  ImageMediaQuery["None"] = "";
  ImageMediaQuery["MobileLarge"] = "only screen and (min-width: 420px)";
  ImageMediaQuery["Tablet"] = "only screen and (min-width: 768px)";
  ImageMediaQuery["Desktop"] = "only screen and (min-width: 1024px)";
})(ImageMediaQuery || (ImageMediaQuery = {}));
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__("HR29");
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);

// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Image/styles.ts


var styles = StyleSheet_default.a.create({
  wrapper: {
    position: 'relative',
    overflow: 'hidden',
    width: '100%'
  },
  placeholder: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%'
  },
  imageNative: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%'
  }
});
var webStyles = {
  placeholderBackground: {
    backgroundImage: "linear-gradient(-90deg, #dddddd 0%, ".concat(theme["a" /* Color */].White, " 50%, #dddddd 100%)"),
    backgroundSize: '400% 400%',
    backgroundPosition: '0% 0%',
    opacity: 0.8
  }
};
/* harmony default export */ var Image_styles = (styles);
// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Image/utils.ts
/*
 * Generate an array that can be used to create source elements in the picture
 * element.
 */
var generateSources = function generateSources(_ref) {
  var uri = _ref.uri,
      imageLoader = _ref.imageLoader,
      imageFixedOptions = _ref.imageFixedOptions,
      imageResponsiveOptions = _ref.imageResponsiveOptions,
      imageFillOptions = _ref.imageFillOptions;
  var sources = [];

  if (imageFixedOptions) {
    var ratio = imageFixedOptions.ratio,
        imageWidth = imageFixedOptions.imageWidth;
    sources = [{
      srcSet: "".concat(imageLoader({
        uri: uri,
        width: imageWidth,
        ratio: ratio,
        webPFormat: true
      }), ", ").concat(imageLoader({
        uri: uri,
        width: imageWidth * 2,
        ratio: ratio,
        webPFormat: true
      }), " 2x"),
      type: 'image/webp'
    }, {
      srcSet: "".concat(imageLoader({
        uri: uri,
        width: imageWidth,
        ratio: ratio
      }), ", ").concat(imageLoader({
        uri: uri,
        width: imageWidth * 2,
        ratio: ratio
      }), " 2x")
    }];
  } else if (imageResponsiveOptions) {
    var _ratio = imageResponsiveOptions.ratio,
        breakpoints = imageResponsiveOptions.breakpoints;
    sources = breakpoints.flatMap(function (_ref2) {
      var media = _ref2.media,
          imageWidth = _ref2.imageWidth,
          imageHeight = _ref2.imageHeight,
          imageUri = _ref2.imageUri;
      return [{
        srcSet: "".concat(imageLoader({
          uri: imageUri || uri,
          width: imageWidth,
          height: imageHeight,
          ratio: _ratio,
          webPFormat: true
        }), ", ").concat(imageLoader({
          uri: imageUri || uri,
          width: imageWidth * 2,
          height: imageHeight && imageHeight * 2,
          ratio: _ratio,
          webPFormat: true
        }), " 2x"),
        media: media,
        type: 'image/webp'
      }, {
        srcSet: "".concat(imageLoader({
          uri: imageUri || uri,
          width: imageWidth,
          height: imageHeight,
          ratio: _ratio
        }), ", ").concat(imageLoader({
          uri: imageUri || uri,
          width: imageWidth * 2,
          height: imageHeight && imageHeight * 2,
          ratio: _ratio
        }), " 2x"),
        media: media
      }];
    });
  } else if (imageFillOptions) {
    var _breakpoints = imageFillOptions.breakpoints;
    sources = _breakpoints.flatMap(function (_ref3) {
      var media = _ref3.media,
          imageWidth = _ref3.imageWidth,
          imageHeight = _ref3.imageHeight,
          imageUri = _ref3.imageUri;
      return [{
        srcSet: "".concat(imageLoader({
          uri: imageUri || uri,
          width: imageWidth,
          height: imageHeight,
          webPFormat: true
        }), ", ").concat(imageLoader({
          uri: imageUri || uri,
          width: imageWidth * 2,
          height: imageHeight && imageHeight * 2,
          webPFormat: true
        }), " 2x"),
        media: media,
        type: 'image/webp'
      }, {
        srcSet: "".concat(imageLoader({
          uri: imageUri || uri,
          width: imageWidth,
          height: imageHeight
        }), ", ").concat(imageLoader({
          uri: imageUri || uri,
          width: imageWidth * 2,
          height: imageHeight && imageHeight * 2
        }), " 2x"),
        media: media
      }];
    });
  }

  return sources;
};
// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Image/ImageWeb.tsx

var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






 // Intentionally not a registered as StyleSheet to allow for usage with img

var imageStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'center'
};

var ImageWeb_ImageWeb = function ImageWeb(_ref) {
  var alt = _ref.alt,
      uri = _ref.uri,
      imageFixedOptions = _ref.imageFixedOptions,
      imageResponsiveOptions = _ref.imageResponsiveOptions,
      imageFillOptions = _ref.imageFillOptions,
      onLoad = _ref.onLoad,
      layout = _ref.layout,
      imageLoader = _ref.imageLoader,
      animation = _ref.animation,
      isImageDownloaded = _ref.isImageDownloaded;

  /*
    When an image's `onLoad` event is used with SSR, the event might already have fired when React is mounted.
    Fix by manually checking on mount if the image has loaded.
    See https://github.com/facebook/react/issues/12641
  */
  var imgRef = Object(react["useRef"])(null);
  Object(react["useEffect"])(function () {
    var imgElem = imgRef.current;

    if ((imgElem === null || imgElem === void 0 ? void 0 : imgElem.complete) && onLoad) {
      onLoad();
    }
  }, []);
  var defaultSrc = imageLoader({
    uri: uri
  });
  var generatedSources = generateSources({
    uri: uri,
    imageLoader: imageLoader,
    imageFixedOptions: imageFixedOptions,
    imageResponsiveOptions: imageResponsiveOptions,
    imageFillOptions: imageFillOptions
  });
  var ratio = (imageFixedOptions === null || imageFixedOptions === void 0 ? void 0 : imageFixedOptions.ratio) || (imageResponsiveOptions === null || imageResponsiveOptions === void 0 ? void 0 : imageResponsiveOptions.ratio);
  var placeholderWrapperStyle = [];

  if (layout === ImageLayout.Fill) {
    placeholderWrapperStyle.push({
      height: '100%'
    });
  } else {
    placeholderWrapperStyle.push({
      paddingBottom: "".concat(ratio * 100, "%")
    });
  }

  return /*#__PURE__*/react_default.a.createElement(View_default.a, {
    style: [Image_styles.wrapper, placeholderWrapperStyle]
  }, !isImageDownloaded &&
  /*#__PURE__*/
  // Remove background since image might be transparent png.
  react_default.a.createElement(Animated_default.a.View, {
    style: [Image_styles.placeholder, webStyles.placeholderBackground, {
      // @ts-ignore
      backgroundPositionX: animation.interpolate({
        inputRange: [0, 1],
        outputRange: ['0%', '-135%']
      })
    }]
  }), /*#__PURE__*/react_default.a.createElement("picture", null, generatedSources.map(function (_ref2) {
    var srcSet = _ref2.srcSet,
        sizes = _ref2.sizes,
        media = _ref2.media,
        type = _ref2.type;
    return /*#__PURE__*/react_default.a.createElement("source", {
      srcSet: srcSet,
      sizes: sizes,
      media: media,
      type: type,
      key: "".concat(srcSet).concat(type)
    });
  }), /*#__PURE__*/react_default.a.createElement("img", {
    ref: imgRef,
    src: defaultSrc,
    alt: alt,
    style: _objectSpread({}, imageStyle),
    onLoad: onLoad
  })));
};

/* harmony default export */ var Image_ImageWeb = (ImageWeb_ImageWeb);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Image/index.js
var Image = __webpack_require__("+s8S");
var Image_default = /*#__PURE__*/__webpack_require__.n(Image);

// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/molecules/Blog/RequestState.ts
var RequestState;

(function (RequestState) {
  RequestState[RequestState["Loading"] = 0] = "Loading";
  RequestState[RequestState["Done"] = 1] = "Done";
  RequestState[RequestState["Error"] = 2] = "Error";
})(RequestState || (RequestState = {}));

/* harmony default export */ var Blog_RequestState = (RequestState);
// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Image/ImageNative.tsx
var ImageNative_jsx = react_default.a.createElement;








var ImageNative_ImageNative = function ImageNative(_ref) {
  var alt = _ref.alt,
      uri = _ref.uri,
      onLoad = _ref.onLoad,
      requestState = _ref.requestState,
      layout = _ref.layout,
      imageResponsiveOptions = _ref.imageResponsiveOptions,
      imageFixedOptions = _ref.imageFixedOptions,
      animation = _ref.animation,
      imageLoader = _ref.imageLoader;
  var ratio = (imageFixedOptions === null || imageFixedOptions === void 0 ? void 0 : imageFixedOptions.ratio) || (imageResponsiveOptions === null || imageResponsiveOptions === void 0 ? void 0 : imageResponsiveOptions.ratio);
  var placeholderWrapperStyle = layout === ImageLayout.Fill ? {
    height: '100%'
  } : {
    paddingBottom: "".concat(ratio * 100, "%")
  };
  var processedUri = imageLoader({
    uri: uri
  });
  return /*#__PURE__*/react_default.a.createElement(View_default.a, {
    style: placeholderWrapperStyle
  }, /*#__PURE__*/react_default.a.createElement(Animated_default.a.View, {
    style: [Image_styles.placeholder, {
      opacity: animation.interpolate({
        inputRange: [0, 1],
        outputRange: [1, 0.3]
      })
    }]
  }), requestState === Blog_RequestState.Done && /*#__PURE__*/react_default.a.createElement(Image_default.a, {
    source: {
      uri: processedUri
    },
    resizeMode: "cover",
    accessibilityLabel: alt,
    style: Image_styles.imageNative,
    onLoad: onLoad
  }));
};

/* harmony default export */ var Image_ImageNative = (ImageNative_ImageNative);
// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Image/Image.tsx

var Image_jsx = react_default.a.createElement;








var isServer = Platform_default.a.OS === 'web' && false;
var Image_Image = /*#__PURE__*/react_default.a.memo(function (_ref) {
  var uri = _ref.uri,
      alt = _ref.alt,
      imageLoader = _ref.imageLoader,
      layout = _ref.layout,
      imageFillOptions = _ref.imageFillOptions,
      imageFixedOptions = _ref.imageFixedOptions,
      imageResponsiveOptions = _ref.imageResponsiveOptions,
      onLoad = _ref.onLoad,
      requestState = _ref.requestState,
      containerStyle = _ref.containerStyle;
  var animation = react_default.a.useRef(new Animated_default.a.Value(0)).current;

  var _React$useState = react_default.a.useState(false),
      _React$useState2 = Object(slicedToArray["a" /* default */])(_React$useState, 2),
      isImageDownloaded = _React$useState2[0],
      setIsImageDownloaded = _React$useState2[1];
  /*
   * webUri: Uri for fallback <img> on web
   * nativeUri: Uri to image in native image component
   * sources: Collection of media queries and srcSet strings for <source> elements
   * in the <picture> element
   */


  var loop = Animated_default.a.loop(Animated_default.a.timing(animation, {
    toValue: 1,
    duration: 1300,
    // useNativeDrive is not supported by react-native-web
    useNativeDriver: false
  }));

  if (isImageDownloaded) {
    if (!isServer) {
      loop.stop();
    }
  } else {
    if (!isServer) {
      // Don't run server side to avoid requestAnimationFrame error
      loop.start();
    }
  }

  var handleOnLoad = react_default.a.useCallback(function () {
    setIsImageDownloaded(true);

    if (onLoad) {
      onLoad();
    }
  }, [setIsImageDownloaded]);
  var wrapperStyle = [Image_styles.wrapper];

  if (layout === ImageLayout.Fill) {
    wrapperStyle.push({
      height: '100%'
    });
  }

  if (layout === ImageLayout.Fixed) {
    wrapperStyle.push({
      width: imageFixedOptions.imageWidth
    });
  }

  return /*#__PURE__*/react_default.a.createElement(View_default.a, {
    style: [wrapperStyle, containerStyle]
  }, Platform_default.a.OS === 'web' ?
  /*#__PURE__*/
  // @ts-ignore there's a weird typescript error that is not that is not valid: Type 'ImageLayout' is not assignable to type 'ImageLayout.Fixed'
  react_default.a.createElement(Image_ImageWeb, {
    uri: uri,
    alt: alt,
    imageFixedOptions: imageFixedOptions,
    imageFillOptions: imageFillOptions,
    imageResponsiveOptions: imageResponsiveOptions,
    layout: layout,
    imageLoader: imageLoader,
    animation: animation,
    isImageDownloaded: isImageDownloaded,
    requestState: requestState,
    onLoad: handleOnLoad
  }) :
  /*#__PURE__*/
  // @ts-ignore there's a weird typescript error that is not that is not valid: Type 'ImageLayout' is not assignable to type 'ImageLayout.Fixed'
  react_default.a.createElement(Image_ImageNative, {
    uri: uri,
    alt: alt,
    layout: layout,
    imageFillOptions: imageFillOptions,
    imageFixedOptions: imageFixedOptions,
    imageResponsiveOptions: imageResponsiveOptions,
    imageLoader: imageLoader,
    animation: animation,
    isImageDownloaded: isImageDownloaded,
    requestState: requestState,
    onLoad: handleOnLoad
  }));
});
/* harmony default export */ var atoms_Image_Image = (Image_Image);
// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Image/loaders/butterLoader.ts
/**
 * Image loaders abstracts away the image manipulation parameteres of the different providers (imgix, butterCMS etc).
 */
function butterLoader(_ref) {
  var uri = _ref.uri,
      width = _ref.width,
      heightInput = _ref.height,
      ratio = _ref.ratio,
      quality = _ref.quality,
      webPFormat = _ref.webPFormat;
  var split = uri.split('/');
  var base = split.slice(0, -1); // We need to extract the resource id as it has to be in the end of the url

  var resourceId = split.slice(-1);
  var height = width && ratio ? Math.ceil(width * ratio) : heightInput;
  var params = []; // Order matters, the 'output' parameters need to be before width/height

  if (quality || webPFormat) {
    var outputParams = [];

    if (quality) {
      outputParams.push("q:".concat(quality));
    }

    if (webPFormat) {
      outputParams.push('format:webp');
    }

    params.push("output=".concat(outputParams.join(',')));
  }

  var widthParam = width ? "w:".concat(width, ",") : '';
  var heightParam = height ? "h:".concat(height, ",") : '';

  if (widthParam || heightParam) {
    params.push("resize=".concat(widthParam).concat(heightParam, "f:crop"));
  }

  return "".concat(base.join('/'), "/").concat(params.join('/'), "/").concat(resourceId[0]);
}

/* harmony default export */ var loaders_butterLoader = (butterLoader);
// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Image/loaders/imgixLoader.ts
/**
 * Image loaders abstracts away the image manipulation parameteres of the different providers (imgix, butterCMS etc).
 */
function imgixLoader(_ref) {
  var uri = _ref.uri,
      width = _ref.width,
      heightInput = _ref.height,
      ratio = _ref.ratio,
      quality = _ref.quality,
      webPFormat = _ref.webPFormat;
  var height = heightInput || width && ratio && Math.ceil(width * ratio);
  var params = ['fit=crop'];
  if (webPFormat) params.push('fm=webp');
  if (width) params.push("w=".concat(width));
  if (height) params.push("h=".concat(height));
  if (quality) params.push("q=".concat(quality));
  return "".concat(uri, "?").concat(params.join('&'));
}

/* harmony default export */ var loaders_imgixLoader = (imgixLoader);
// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Image/loaders/defaultLoader.ts
/**
 *  Default loader simply return the uri
 */
function defaultLoader(_ref) {
  var uri = _ref.uri;
  return uri;
}

/* harmony default export */ var loaders_defaultLoader = (defaultLoader);
// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Image/index.tsx








/***/ }),

/***/ "Me73":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ molecules_FlexList_FlexList; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ FlexListJustifyContent; });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/View/index.js
var View = __webpack_require__("Epja");
var View_default = /*#__PURE__*/__webpack_require__.n(View);

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__("HR29");
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/molecules/Composition/index.ts + 16 modules
var Composition = __webpack_require__("C2Jz");

// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/molecules/FlexList/FlexList.tsx
var __jsx = react_default.a.createElement;




var FlexListJustifyContent;

(function (FlexListJustifyContent) {
  FlexListJustifyContent["Start"] = "flex-start";
  FlexListJustifyContent["End"] = "flex-end";
  FlexListJustifyContent["Center"] = "center";
  FlexListJustifyContent["SpaceBetween"] = "space-between";
  FlexListJustifyContent["SpaceAround"] = "space-around";
  FlexListJustifyContent["SpaceEvenly"] = "space-evenly";
})(FlexListJustifyContent || (FlexListJustifyContent = {}));

var styles = StyleSheet_default.a.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    flexWrap: 'wrap'
  }
});

var FlexList_FlexList = function FlexList(_ref) {
  var data = _ref.data,
      renderItem = _ref.renderItem,
      keyExtractor = _ref.keyExtractor,
      gapHorizontal = _ref.gapHorizontal,
      justifyContent = _ref.justifyContent,
      gapVertical = _ref.gapVertical;
  return /*#__PURE__*/react_default.a.createElement(Composition["g" /* default */], null, /*#__PURE__*/react_default.a.createElement(Composition["b" /* Layout */], {
    omitPadding: true,
    direction: Composition["d" /* LayoutDirection */].Row,
    alignX: Composition["c" /* LayoutAlignment */].Start,
    alignY: Composition["c" /* LayoutAlignment */].Start
  }, /*#__PURE__*/react_default.a.createElement(View_default.a, {
    style: [styles.container, {
      justifyContent: justifyContent,
      marginVertical: -gapVertical / 2,
      marginHorizontal: -gapHorizontal / 2
    }]
  }, data.map(function (item, index) {
    return /*#__PURE__*/react_default.a.createElement(View_default.a, {
      style: {
        marginVertical: gapVertical / 2,
        marginHorizontal: gapHorizontal / 2
      },
      key: keyExtractor(item)
    }, renderItem({
      index: index,
      item: item
    }), /*#__PURE__*/react_default.a.createElement(Composition["e" /* Spacer */], {
      direction: Composition["f" /* SpacerDirection */].Horizontal,
      size: gapHorizontal
    }));
  }))));
};

/* harmony default export */ var molecules_FlexList_FlexList = (FlexList_FlexList);
// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/molecules/FlexList/index.ts


/***/ }),

/***/ "esOp":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/hero-image-4aeb68363b181f59965f2eea960f75e6.png", "placeholder": ""};

/***/ }),

/***/ "kdLy":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/45-day-soundcheck",
      function () {
        return __webpack_require__("vTE/");
      }
    ]);
  

/***/ }),

/***/ "vTE/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/@lingui/react/index.js
var _lingui_react = __webpack_require__("ZD0w");

// EXTERNAL MODULE: ./components/shared/Meta/index.js + 6 modules
var Meta = __webpack_require__("ACIN");

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Image/index.tsx + 10 modules
var Image = __webpack_require__("D+Wi");

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Text/index.tsx
var Text = __webpack_require__("Zd2Y");

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/styles/theme.ts
var theme = __webpack_require__("isV7");

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/molecules/Composition/index.ts + 16 modules
var Composition = __webpack_require__("C2Jz");

// EXTERNAL MODULE: ./components/pages/100DaySoundcheck/sections/SectionWrapper.tsx
var SectionWrapper = __webpack_require__("7UQC");

// CONCATENATED MODULE: ./components/pages/100DaySoundcheck/sections/Hero.tsx
var __jsx = react_default.a.createElement;








var Hero_Hero = function Hero(_ref) {
  var image = _ref.image,
      title = _ref.title,
      description = _ref.description;
  return /*#__PURE__*/react_default.a.createElement(Composition["g" /* default */], null, /*#__PURE__*/react_default.a.createElement(Composition["a" /* BackgroundColor */], {
    color: theme["a" /* Color */].Charcoal
  }), /*#__PURE__*/react_default.a.createElement(SectionWrapper["a" /* default */], null, /*#__PURE__*/react_default.a.createElement(Composition["b" /* Layout */], {
    direction: Composition["d" /* LayoutDirection */].Column,
    alignX: Composition["c" /* LayoutAlignment */].Center,
    alignY: Composition["c" /* LayoutAlignment */].Start
  }, /*#__PURE__*/react_default.a.createElement(Image["d" /* default */], {
    alt: image.alt,
    imageLoader: Image["e" /* imgixLoader */],
    layout: Image["a" /* ImageLayout */].Fixed,
    imageFixedOptions: {
      ratio: image.imageRatio,
      imageWidth: Image["c" /* ImageWidth */].Medium
    },
    uri: image.uri
  }), /*#__PURE__*/react_default.a.createElement(Composition["e" /* Spacer */], {
    direction: Composition["f" /* SpacerDirection */].Vertical,
    size: theme["l" /* Space */].MediumLarge
  }), /*#__PURE__*/react_default.a.createElement(TextWrapper, null, /*#__PURE__*/react_default.a.createElement(Text["j" /* default */], {
    textAlign: Text["f" /* TextAlign */].Center,
    type: Text["i" /* TextType */].HighlightLarge,
    colorForeground: theme["a" /* Color */].White
  }, title), /*#__PURE__*/react_default.a.createElement(Composition["e" /* Spacer */], {
    direction: Composition["f" /* SpacerDirection */].Vertical,
    size: theme["l" /* Space */].MediumLarge
  }), /*#__PURE__*/react_default.a.createElement(Text["j" /* default */], {
    textAlign: Text["f" /* TextAlign */].Center,
    type: Text["i" /* TextType */].ParagraphLarge,
    colorForeground: theme["a" /* Color */].White
  }, description)))));
};

var TextWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Hero__TextWrapper",
  componentId: "sc-1nzp9vp-0"
})(["width:", "px;text-align:center;"], theme["j" /* Size */].BaseUnit * 44);
/* harmony default export */ var sections_Hero = (Hero_Hero);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__("HR29");
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/View/index.js
var View = __webpack_require__("Epja");
var View_default = /*#__PURE__*/__webpack_require__.n(View);

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Icon/index.tsx + 105 modules
var Icon = __webpack_require__("ZSX1");

// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/molecules/Callout/Callout.tsx
var Callout_jsx = react_default.a.createElement;

/* eslint-disable object-curly-newline */






var styles = StyleSheet_default.a.create({
  container: {
    alignItems: 'center',
    maxWidth: 37 * theme["j" /* Size */].BaseUnit
  },
  iconBox: {
    width: 18 * theme["j" /* Size */].BaseUnit,
    height: 18 * theme["j" /* Size */].BaseUnit,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme["a" /* Color */].WhiteOff
  },
  titleBox: {
    top: -19,
    height: 39,
    paddingLeft: 3,
    paddingRight: 4,
    backgroundColor: theme["a" /* Color */].Charcoal
  }
});

var Callout_Callout = function Callout(_ref) {
  var iconId = _ref.iconId,
      title = _ref.title,
      text = _ref.text;
  return /*#__PURE__*/react_default.a.createElement(View_default.a, {
    style: styles.container
  }, /*#__PURE__*/react_default.a.createElement(View_default.a, {
    style: styles.iconBox
  }, /*#__PURE__*/react_default.a.createElement(Icon["b" /* default */], {
    id: iconId,
    color: theme["a" /* Color */].Charcoal,
    size: 80
  })), /*#__PURE__*/react_default.a.createElement(View_default.a, {
    style: styles.titleBox
  }, /*#__PURE__*/react_default.a.createElement(Text["j" /* default */], {
    type: Text["i" /* TextType */].HeadingSmall,
    headingLevel: 3,
    colorForeground: theme["a" /* Color */].White,
    textTransform: Text["h" /* TextTransform */].UpperCase,
    textAlign: Text["f" /* TextAlign */].Center,
    lineHeight: 36
  }, title)), /*#__PURE__*/react_default.a.createElement(Text["j" /* default */], {
    type: Text["i" /* TextType */].ParagraphLarge,
    colorForeground: theme["a" /* Color */].Charcoal,
    textAlign: Text["f" /* TextAlign */].Center
  }, text));
};

/* harmony default export */ var molecules_Callout_Callout = (Callout_Callout);
// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/molecules/FlexList/index.ts + 1 modules
var FlexList = __webpack_require__("Me73");

// EXTERNAL MODULE: ./components/atoms/Link/index.tsx
var Link = __webpack_require__("ZT91");

// EXTERNAL MODULE: ./components/atoms/Button/index.js + 7 modules
var Button = __webpack_require__("8BE4");

// CONCATENATED MODULE: ./components/pages/100DaySoundcheck/sections/HowItWorks.tsx
var HowItWorks_jsx = react_default.a.createElement;










var HowItWorks_renderItemCallout = function renderItemCallout(_ref) {
  var _ref$item = _ref.item,
      iconId = _ref$item.iconId,
      title = _ref$item.title,
      text = _ref$item.text;
  return /*#__PURE__*/react_default.a.createElement(molecules_Callout_Callout, {
    iconId: iconId,
    text: text,
    title: title
  });
};

var HowItWorks_HowItWorks = function HowItWorks(_ref2) {
  var title = _ref2.title,
      calloutData = _ref2.calloutData,
      ctaButton = _ref2.ctaButton;
  return /*#__PURE__*/react_default.a.createElement(Composition["g" /* default */], {
    explodeHeight: true
  }, /*#__PURE__*/react_default.a.createElement(Composition["a" /* BackgroundColor */], {
    color: theme["a" /* Color */].White
  }), /*#__PURE__*/react_default.a.createElement(SectionWrapper["a" /* default */], null, /*#__PURE__*/react_default.a.createElement(Composition["b" /* Layout */], {
    direction: Composition["d" /* LayoutDirection */].Column,
    alignX: Composition["c" /* LayoutAlignment */].Center,
    alignY: Composition["c" /* LayoutAlignment */].Start
  }, /*#__PURE__*/react_default.a.createElement(Text["j" /* default */], {
    textAlign: Text["f" /* TextAlign */].Center,
    type: Text["i" /* TextType */].HeadingSmall,
    colorForeground: theme["a" /* Color */].Primary,
    textTransform: Text["h" /* TextTransform */].UpperCase
  }, title), /*#__PURE__*/react_default.a.createElement(Composition["e" /* Spacer */], {
    direction: Composition["f" /* SpacerDirection */].Vertical,
    size: theme["l" /* Space */].ExtraLarge
  }), /*#__PURE__*/react_default.a.createElement(FlexList["b" /* default */], {
    gapHorizontal: theme["l" /* Space */].ExtraLarge,
    gapVertical: theme["l" /* Space */].ExtraLarge,
    justifyContent: FlexList["a" /* FlexListJustifyContent */].Center,
    data: calloutData,
    renderItem: HowItWorks_renderItemCallout,
    keyExtractor: function keyExtractor(_ref3) {
      var iconId = _ref3.iconId;
      return iconId.toString();
    }
  }), /*#__PURE__*/react_default.a.createElement(Composition["e" /* Spacer */], {
    direction: Composition["f" /* SpacerDirection */].Vertical,
    size: theme["l" /* Space */].Large
  }), /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
    href: ctaButton.href,
    as: ctaButton.as
  }, /*#__PURE__*/react_default.a.createElement(Button["b" /* PrimaryButton */], {
    id: "howitworks-button-100-day-soundcheck"
  }, ctaButton.text)))));
};

/* harmony default export */ var sections_HowItWorks = (HowItWorks_HowItWorks);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Pressable/index.js
var Pressable = __webpack_require__("XY2T");
var Pressable_default = /*#__PURE__*/__webpack_require__.n(Pressable);

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Animated/index.js
var Animated = __webpack_require__("ilP0");
var Animated_default = /*#__PURE__*/__webpack_require__.n(Animated);

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Platform/index.js
var Platform = __webpack_require__("Hnp+");
var Platform_default = /*#__PURE__*/__webpack_require__.n(Platform);

// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/molecules/Accordion/AccordionItemExpandable.tsx
var AccordionItemExpandable_jsx = react_default.a.createElement;










var AccordionItemExpandable_AccordionItemExpandable = function AccordionItemExpandable(_ref) {
  var colorForeground = _ref.colorForeground,
      title = _ref.title,
      content = _ref.content,
      id = _ref.id,
      isExpanded = _ref.isExpanded,
      onChange = _ref.onChange;
  var rotatePlusAnim = react_default.a.useRef(new Animated_default.a.Value(0)).current;

  var rotateToOpen = function rotateToOpen() {
    Animated_default.a.timing(rotatePlusAnim, {
      useNativeDriver: Platform_default.a.OS !== 'web',
      toValue: 45,
      duration: 200
    }).start();
  };

  var rotateToClosed = function rotateToClosed() {
    Animated_default.a.timing(rotatePlusAnim, {
      useNativeDriver: Platform_default.a.OS !== 'web',
      toValue: 0,
      duration: 200
    }).start();
  };

  Object(react["useEffect"])(function () {
    if (isExpanded) {
      rotateToOpen();
    } else {
      rotateToClosed();
    }
  }, [isExpanded]);
  return /*#__PURE__*/react_default.a.createElement(View_default.a, {
    style: {
      overflow: 'hidden'
    }
  }, /*#__PURE__*/react_default.a.createElement(Pressable_default.a, {
    onPress: function onPress() {
      return onChange(id);
    }
  }, /*#__PURE__*/react_default.a.createElement(Composition["b" /* Layout */], {
    omitPadding: true,
    direction: Composition["d" /* LayoutDirection */].Row,
    alignX: Composition["c" /* LayoutAlignment */].SpaceBetween,
    alignY: Composition["c" /* LayoutAlignment */].Center
  }, /*#__PURE__*/react_default.a.createElement(Text["j" /* default */], {
    colorForeground: colorForeground,
    type: Text["i" /* TextType */].Button
  }, title), /*#__PURE__*/react_default.a.createElement(Animated_default.a.View, {
    style: {
      transform: [{
        rotate: rotatePlusAnim.interpolate({
          inputRange: [0, 45],
          outputRange: ['0deg', '45deg']
        })
      }]
    }
  }, /*#__PURE__*/react_default.a.createElement(Icon["b" /* default */], {
    id: Icon["a" /* IconId */].Add,
    color: colorForeground,
    size: theme["d" /* IconSize */].Small
  })))), /*#__PURE__*/react_default.a.createElement(View_default.a, {
    style: {
      height: isExpanded ? 'auto' : 0
    }
  }, /*#__PURE__*/react_default.a.createElement(Composition["e" /* Spacer */], {
    direction: Composition["f" /* SpacerDirection */].Vertical,
    size: theme["l" /* Space */].Small
  }), content, /*#__PURE__*/react_default.a.createElement(Composition["e" /* Spacer */], {
    direction: Composition["f" /* SpacerDirection */].Vertical,
    size: theme["l" /* Space */].Small
  })));
};

/* harmony default export */ var Accordion_AccordionItemExpandable = (AccordionItemExpandable_AccordionItemExpandable);
// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/molecules/Accordion/AccordionItemLink.tsx
var AccordionItemLink_jsx = react_default.a.createElement;






var AccordionItemLink_AccordionItemLink = function AccordionItemLink(_ref) {
  var colorForeground = _ref.colorForeground,
      title = _ref.title,
      LinkComponent = _ref.LinkComponent;
  return /*#__PURE__*/react_default.a.createElement(LinkComponent, null, /*#__PURE__*/react_default.a.createElement(Composition["b" /* Layout */], {
    omitPadding: true,
    direction: Composition["d" /* LayoutDirection */].Row,
    alignX: Composition["c" /* LayoutAlignment */].SpaceBetween,
    alignY: Composition["c" /* LayoutAlignment */].Center
  }, /*#__PURE__*/react_default.a.createElement(Text["j" /* default */], {
    colorForeground: colorForeground,
    type: Text["i" /* TextType */].Button
  }, title), /*#__PURE__*/react_default.a.createElement(Icon["b" /* default */], {
    id: Icon["a" /* IconId */].Forward,
    color: colorForeground,
    size: theme["d" /* IconSize */].Small
  })));
};

/* harmony default export */ var Accordion_AccordionItemLink = (AccordionItemLink_AccordionItemLink);
// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/molecules/Accordion/types.ts
var AccordionItemType;

(function (AccordionItemType) {
  AccordionItemType[AccordionItemType["Link"] = 0] = "Link";
  AccordionItemType[AccordionItemType["Expandable"] = 1] = "Expandable";
})(AccordionItemType || (AccordionItemType = {}));
// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/molecules/Accordion/Accordion.tsx
var Accordion_jsx = react_default.a.createElement;






var BORDER_WIDTH = 1;

var Accordion_Accordion = function Accordion(_ref) {
  var items = _ref.items,
      colorForeground = _ref.colorForeground,
      onChange = _ref.onChange;
  return /*#__PURE__*/react_default.a.createElement(View_default.a, null, items.map(function (item, i) {
    return /*#__PURE__*/react_default.a.createElement(View_default.a, {
      key: item.id,
      style: {
        paddingVertical: theme["j" /* Size */].BaseUnit * 1,
        borderBottomWidth: BORDER_WIDTH,
        borderBottomColor: colorForeground,
        // only give the first index, a borderTop
        borderTopWidth: i === 0 ? BORDER_WIDTH : 0,
        borderTopColor: colorForeground
      }
    }, item.type === AccordionItemType.Link && /*#__PURE__*/react_default.a.createElement(Accordion_AccordionItemLink, {
      colorForeground: colorForeground,
      title: item.title,
      LinkComponent: item.LinkComponent
    }), item.type === AccordionItemType.Expandable && /*#__PURE__*/react_default.a.createElement(Accordion_AccordionItemExpandable, {
      colorForeground: colorForeground,
      title: item.title,
      content: item.content,
      id: item.id,
      isExpanded: item.isExpanded,
      onChange: onChange
    }));
  }));
};

/* harmony default export */ var molecules_Accordion_Accordion = (Accordion_Accordion);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/molecules/Accordion/useAccordionState.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


 // Special type that keeps all properties (except the omitted one) and not only the intersection properties. Taken from https://davidgomes.com/pick-omit-over-union-types-in-typescript/

var useAccordionState_useAccordionState = function useAccordionState(_ref) {
  var initialItems = _ref.initialItems;

  var _useState = Object(react["useState"])( // Set the id unique value (with symbol)
  function () {
    return initialItems.map(function (initialItem, i) {
      return _objectSpread(_objectSpread({}, initialItem), {}, {
        id: i
      });
    });
  }),
      items = _useState[0],
      setItems = _useState[1];

  var onChange = function onChange(id) {
    var updatedItems = items.map(function (item) {
      if (item.type === AccordionItemType.Expandable) {
        return item.id === id ? _objectSpread(_objectSpread({}, item), {}, {
          isExpanded: !item.isExpanded
        }) : item;
      }

      return item;
    });
    setItems(updatedItems);
  };

  return {
    items: items,
    onChange: onChange
  };
};

/* harmony default export */ var Accordion_useAccordionState = (useAccordionState_useAccordionState);
// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/molecules/Accordion/index.ts





// CONCATENATED MODULE: ./components/pages/100DaySoundcheck/sections/Warranty.tsx
var Warranty_jsx = react_default.a.createElement;








var Warranty_Warranty = function Warranty(_ref) {
  var title = _ref.title,
      accordionItems = _ref.accordionItems;

  var _useAccordionState = Accordion_useAccordionState({
    initialItems: accordionItems
  }),
      items = _useAccordionState.items,
      onChange = _useAccordionState.onChange;

  return /*#__PURE__*/react_default.a.createElement(Composition["g" /* default */], null, /*#__PURE__*/react_default.a.createElement(Composition["a" /* BackgroundColor */], {
    color: theme["a" /* Color */].WhiteOff
  }), /*#__PURE__*/react_default.a.createElement(SectionWrapper["a" /* default */], {
    maxWidth: theme["c" /* ContentMaxWidth */].Large
  }, /*#__PURE__*/react_default.a.createElement(ContentWrapper, null, /*#__PURE__*/react_default.a.createElement(TitleWrapper, null, /*#__PURE__*/react_default.a.createElement(Text["j" /* default */], {
    type: Text["i" /* TextType */].HeadingSmall,
    textTransform: Text["h" /* TextTransform */].UpperCase,
    colorForeground: theme["a" /* Color */].Charcoal
  }, title)), /*#__PURE__*/react_default.a.createElement(AccordionWrapper, null, /*#__PURE__*/react_default.a.createElement(molecules_Accordion_Accordion, {
    onChange: onChange,
    items: items,
    colorForeground: theme["a" /* Color */].Charcoal
  })))));
};

var ContentWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Warranty__ContentWrapper",
  componentId: "dvcw1d-0"
})(["position:relative;display:flex;flex-direction:column;justify-content:space-between;align-items:center;& > *{margin-bottom:", "px;}& > *:last-child{margin-bottom:0;}@media ", "{flex-direction:row;align-items:flex-start;& > *{margin-bottom:0;}}"], theme["j" /* Size */].BaseUnit * 6, function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.desktop;
});
var TitleWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Warranty__TitleWrapper",
  componentId: "dvcw1d-1"
})(["max-width:", "px;text-align:center;@media ", "{text-align:left;}"], theme["j" /* Size */].BaseUnit * 37, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.desktop;
});
var AccordionWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Warranty__AccordionWrapper",
  componentId: "dvcw1d-2"
})(["max-width:", "px;"], theme["j" /* Size */].BaseUnit * 57);
/* harmony default export */ var sections_Warranty = (Warranty_Warranty);
// CONCATENATED MODULE: ./components/pages/100DaySoundcheck/sections/Support.tsx
var Support_jsx = react_default.a.createElement;






var Support_Support = function Support(_ref) {
  var title = _ref.title,
      contact = _ref.contact;
  return /*#__PURE__*/react_default.a.createElement(Composition["g" /* default */], null, /*#__PURE__*/react_default.a.createElement(Composition["a" /* BackgroundColor */], {
    color: theme["a" /* Color */].White
  }), /*#__PURE__*/react_default.a.createElement(SectionWrapper["a" /* default */], {
    maxWidth: theme["c" /* ContentMaxWidth */].Large
  }, /*#__PURE__*/react_default.a.createElement(Composition["b" /* Layout */], {
    direction: Composition["d" /* LayoutDirection */].Column,
    alignX: Composition["c" /* LayoutAlignment */].Center,
    alignY: Composition["c" /* LayoutAlignment */].Start
  }, /*#__PURE__*/react_default.a.createElement(Text["j" /* default */], {
    textAlign: Text["f" /* TextAlign */].Center,
    type: Text["i" /* TextType */].Heading,
    textTransform: Text["h" /* TextTransform */].UpperCase,
    colorForeground: theme["a" /* Color */].Charcoal
  }, title), /*#__PURE__*/react_default.a.createElement(Composition["e" /* Spacer */], {
    direction: Composition["f" /* SpacerDirection */].Vertical,
    size: theme["l" /* Space */].Medium
  }), /*#__PURE__*/react_default.a.createElement(Text["j" /* default */], {
    textAlign: Text["f" /* TextAlign */].Center,
    type: Text["i" /* TextType */].HighlightLarge,
    colorForeground: theme["a" /* Color */].Charcoal
  }, contact))));
};

/* harmony default export */ var sections_Support = (Support_Support);
// CONCATENATED MODULE: ./components/pages/100DaySoundcheck/index.tsx
var _100DaySoundcheck_jsx = react_default.a.createElement;






var _100DaySoundcheck_HundredDaySoundcheck = function HundredDaySoundcheck(_ref) {
  var heroSection = _ref.heroSection,
      howItWorksSection = _ref.howItWorksSection,
      warrantySection = _ref.warrantySection,
      supportSection = _ref.supportSection;
  return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(sections_Hero, heroSection), /*#__PURE__*/react_default.a.createElement(sections_HowItWorks, howItWorksSection), /*#__PURE__*/react_default.a.createElement(sections_Warranty, warrantySection), /*#__PURE__*/react_default.a.createElement(sections_Support, supportSection));
};

/* harmony default export */ var _100DaySoundcheck = (_100DaySoundcheck_HundredDaySoundcheck);
// EXTERNAL MODULE: ./components/pages/100DaySoundcheck/assets/hero-image.png
var hero_image = __webpack_require__("esOp");
var hero_image_default = /*#__PURE__*/__webpack_require__.n(hero_image);

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/TouchableWithoutFeedback/index.js
var TouchableWithoutFeedback = __webpack_require__("PiEE");
var TouchableWithoutFeedback_default = /*#__PURE__*/__webpack_require__.n(TouchableWithoutFeedback);

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Linking/index.js
var Linking = __webpack_require__("ZYDq");
var Linking_default = /*#__PURE__*/__webpack_require__.n(Linking);

// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Link/index.tsx
var Link_jsx = react_default.a.createElement;





var Link_Link = /*#__PURE__*/react_default.a.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      href = _ref.href,
      _ref$external = _ref.external,
      external = _ref$external === void 0 ? false : _ref$external,
      _ref$propagate = _ref.propagate,
      propagate = _ref$propagate === void 0 ? false : _ref$propagate,
      onClick = _ref.onClick,
      onPress = _ref.onPress;
  var target = external ? '_blank' : '';
  var rel = external ? 'noopener noreferrer' : '';

  var handleOnClick = function handleOnClick(e) {
    if (!propagate) e.stopPropagation();
    if (onClick) onClick(e);
    if (onPress) onPress(e);
  };

  var handleOnPress = function handleOnPress(e) {
    if (!propagate) e.stopPropagation();
    if (onClick) onClick(e);
    if (onPress) onPress(e);

    if (href) {
      Linking_default.a.openURL(href);
    }
  };

  if (Platform_default.a.OS === 'web') {
    return /*#__PURE__*/react_default.a.createElement("a", {
      href: href,
      target: target,
      rel: rel,
      ref: ref,
      onClick: handleOnClick
    }, children);
  }

  return /*#__PURE__*/react_default.a.createElement(TouchableWithoutFeedback_default.a, {
    onPress: handleOnPress
  }, /*#__PURE__*/react_default.a.createElement(View_default.a, null, children));
});
/* harmony default export */ var atoms_Link = (Link_Link);
// EXTERNAL MODULE: ./components/wrappers/Layout/index.js + 33 modules
var Layout = __webpack_require__("8hyx");

// CONCATENATED MODULE: ./pages/45-day-soundcheck.tsx
var _45_day_soundcheck_jsx = react_default.a.createElement;













var HERO_IMAGE_RATIO = 2285 / 1920;

var _45_day_soundcheck_HundredDaySoundcheckPage = function HundredDaySoundcheckPage() {
  var pageInfo = {
    title:
    /*i18n*/
    {
      id: "page.100DaySoundcheck.meta.title"
    },
    desc:
    /*i18n*/
    {
      id: "page.100DaySoundcheck.meta.desc"
    },
    url: '/45-day-soundcheck'
  };
  return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(Layout["a" /* default */], null, /*#__PURE__*/react_default.a.createElement(Meta["a" /* default */], {
    pageInfo: pageInfo
  }), /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref) {
    var i18n = _ref.i18n;
    return /*#__PURE__*/react_default.a.createElement(_100DaySoundcheck, {
      heroSection: {
        image: {
          alt: i18n._(
          /*i18n*/
          {
            id: "page.100DaySoundcheck.hero.image.alt"
          }),
          imageRatio: HERO_IMAGE_RATIO,
          uri: hero_image_default.a.url
        },
        title: i18n._(
        /*i18n*/
        {
          id: "page.100DaySoundcheck.hero.title"
        }),
        description: i18n._(
        /*i18n*/
        {
          id: "page.100DaySoundcheck.hero.description"
        })
      },
      howItWorksSection: {
        title: i18n._(
        /*i18n*/
        {
          id: "page.100DaySoundcheck.howItWorks.title"
        }),
        calloutData: [{
          iconId: Icon["a" /* IconId */].Cart,
          title: i18n._(
          /*i18n*/
          {
            id: "page.100DaySoundcheck.howItWorks.shop.title"
          }),
          text: i18n._(
          /*i18n*/
          {
            id: "page.100DaySoundcheck.howItWorks.shop.text"
          })
        }, {
          iconId: Icon["a" /* IconId */].Playlist,
          title: i18n._(
          /*i18n*/
          {
            id: "page.100DaySoundcheck.howItWorks.play.title"
          }),
          text: i18n._(
          /*i18n*/
          {
            id: "page.100DaySoundcheck.howItWorks.play.text"
          })
        }, {
          iconId: Icon["a" /* IconId */].Check,
          title: i18n._(
          /*i18n*/
          {
            id: "page.100DaySoundcheck.howItWorks.decide.title"
          }),
          text: i18n._(
          /*i18n*/
          {
            id: "page.100DaySoundcheck.howItWorks.decide.text"
          })
        }],
        ctaButton: {
          as: '/products/soundboks-gen-3',
          href: '/products/product?productHandle=soundboks-gen-3',
          text: i18n._(
          /*i18n*/
          {
            id: "page.100DaySoundcheck.howItWorks.ctaText"
          })
        }
      },
      warrantySection: {
        title: i18n._(
        /*i18n*/
        {
          id: "page.100DaySoundcheck.warranty.title"
        }),
        accordionItems: [{
          type: AccordionItemType.Expandable,
          isExpanded: false,
          title: i18n._(
          /*i18n*/
          {
            id: "page.100DaySoundcheck.warranty.accordion.expandable.title"
          }),
          content: /*#__PURE__*/react_default.a.createElement(Text["j" /* default */], {
            type: Text["i" /* TextType */].ParagraphLarge,
            colorForeground: theme["a" /* Color */].Charcoal
          }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
            id: "page.100DaySoundcheck.warranty.accordion.expandable.content" // @ts-ignore SBLink requires children, but we can't give it children at this moment
            ,
            components: [/*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement("em", null), /*#__PURE__*/react_default.a.createElement(atoms_Link, {
              href: "/return-n-warranty/"
            })]
          }))
        }, {
          type: AccordionItemType.Link,
          title: i18n._(
          /*i18n*/
          {
            id: "page.100DaySoundcheck.warranty.accordion.link.title"
          }),
          LinkComponent: function LinkComponent(_ref2) {
            var children = _ref2.children;
            return /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
              passHref: true,
              href: "/terms"
            }, /*#__PURE__*/react_default.a.createElement(A, null, children));
          }
        }]
      },
      supportSection: {
        title: i18n._(
        /*i18n*/
        {
          id: "page.100DaySoundcheck.support.title"
        }),
        // eslint-disable-next-line jsx-a11y/control-has-associated-label, jsx-a11y/anchor-has-content
        contact: /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
          id: "page.100DaySoundcheck.support.content",
          components: [/*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement("a", {
            href: "mailto:info@SOUNDBOKS.com"
          }, " ")]
        })
      }
    });
  })));
};

var A = styled_components_browser_esm["default"].a.withConfig({
  displayName: "sc-45-day-soundcheck__A",
  componentId: "sc-1u69ajc-0"
})(["&:hover{text-decoration:none;}"]);
/* harmony default export */ var _45_day_soundcheck = __webpack_exports__["default"] = (_45_day_soundcheck_HundredDaySoundcheckPage);

/***/ })

},[["kdLy",0,1,2,3,4,5,6,7,8,12]]]);